import { useEffect, useState } from 'react';
import api from '../../../../services/api';
import { NotificationManager } from 'react-notifications';
import { Col, FlexboxGrid, Form, Grid, Row } from 'rsuite';
import { CustomSelectPicker } from '../../../../components/CustomSelectPicker';
import { CustomInput } from '../../../../components/CustomInput';
import { CustomButton } from '../../../../components/CustomButton';
import { useCustomTheme } from '../../../../hooks/useCustomTheme';
import RModal from '../../../../components/Rsuite/Modal';
import { toastError } from '../../../../toasts';

const EditCreateMontagens = ({
  montagem,
  setMontagens,
  id_empresa,
  close,
  open,
}) => {
  const { theme } = useCustomTheme();
  const [codigoPDV, setCodigoPDV] = useState(0);
  const [descricao, setDescricao] = useState(null);
  const [qtdSemCusto, setQtdSemCusto] = useState(0);
  const [qtdMax, setQtdMax] = useState(0);
  const [qtdMin, setQtdMin] = useState(0);
  const [ativo, setAtivo] = useState(true);
  const [addMaisVezes, setAddMaisVezes] = useState('True');
  const [incrementar, setIncrementar] = useState(1);

  const cadastrarMontagem = async () => {
    try {
      const { data } = await api.post('montagem-prato/criar', {
        IdEmpresa: id_empresa,
        CodigoPDV: codigoPDV,
        Descricao: descricao,
        QtdSemCusto: qtdSemCusto,
        QtdMin: qtdMin,
        QtdMax: qtdMax,
        AddItemMaisVezes: addMaisVezes,
        Incrementar: incrementar,
      });

      NotificationManager.success('Montagem cadastrada', 'Sucesso');
      setMontagens((state) => [...state, data]);
      resetValues();
      close();
    } catch (error) {
      console.log(error);
      toastError('Não foi possivel cadastrar montagem');
    }
  };

  const editarMontagem = async () => {
    if (incrementar === 0 || !incrementar) {
      return NotificationManager.error(
        'Incremento deve ser maior que zero.',
        'Erro',
      );
    }

    try {
      const newData = {
        IdEmpresa: id_empresa,
        CodigoPDV: codigoPDV,
        Descricao: descricao,
        QtdSemCusto: qtdSemCusto,
        QtdMin: qtdMin,
        QtdMax: qtdMax,
        Ativo: ativo,
        AddItemMaisVezes: addMaisVezes,
        Incrementar: incrementar,
      };

      const { data } = await api.patch(
        `montagem-prato/alterar/${montagem?.Id}`,
        newData,
      );

      if (data?.Id) {
        NotificationManager.success('Montagem alterada', 'Sucesso');
        setMontagens((state) =>
          state.map((e) => (e.Id !== data.Id ? e : data)),
        );
        resetValues();
        close();
      }
    } catch (err) {
      console.log(err);
      NotificationManager.error('Não foi possivel alterar a montagem', 'Erro');
    }
  };

  function resetValues() {
    setCodigoPDV(0);
    setDescricao('');
    setQtdSemCusto(0);
    setQtdMax(0);
    setQtdMin(0);
    setAtivo(true);
    setAddMaisVezes('True');
    setIncrementar(1);
  }

  useEffect(() => {
    if (montagem) {
      setCodigoPDV(0); // dado não retornado
      setDescricao(montagem.Descricao);
      setQtdSemCusto(montagem.QtdSemCusto);
      setQtdMax(montagem.QtdMax);
      setQtdMin(montagem.QtdMin);
      setAddMaisVezes('True'); // dado não retornado
      setIncrementar(montagem.Incrementar);
    }
  }, [montagem]);

  return (
    <RModal
      open={open}
      onClose={close}
      title="Cadastrar Montagem"
      size="md"
      footer={<></>}
    >
      <Form>
        <Grid fluid>
          <Row>
            <Col xs={24} md={5}>
              <Form.Group>
                <Form.ControlLabel
                  style={{
                    color: theme.colors.textSecondary,
                    marginTop: '10px',
                  }}
                >
                  Código PDV
                </Form.ControlLabel>
                <Form.Control
                  name="codigoPDV"
                  value={codigoPDV}
                  min={0}
                  onChange={setCodigoPDV}
                  accepter={CustomInput}
                  style={{ width: '100%' }}
                />
              </Form.Group>
            </Col>
            <Col xs={24} md={19}>
              <Form.Group style={{ width: '100%', display: 'grid' }}>
                <Form.ControlLabel
                  style={{
                    color: theme.colors.textSecondary,
                    marginTop: '10px',
                  }}
                >
                  Descrição
                </Form.ControlLabel>
                <Form.Control
                  name="descricao"
                  value={descricao}
                  onChange={setDescricao}
                  accepter={CustomInput}
                  style={{ width: '100%' }}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={24} md={5}>
              <Form.Group>
                <Form.ControlLabel
                  style={{
                    color: theme.colors.textSecondary,
                    marginTop: '10px',
                  }}
                >
                  Qtd. S/Custo
                </Form.ControlLabel>
                <Form.Control
                  name="qtdSemCusto"
                  type="number"
                  value={qtdSemCusto}
                  onChange={setQtdSemCusto}
                  accepter={CustomInput}
                  style={{ width: '100%' }}
                />
              </Form.Group>
            </Col>
            <Col xs={24} md={4}>
              <Form.Group>
                <Form.ControlLabel
                  style={{
                    color: theme.colors.textSecondary,
                    marginTop: '10px',
                  }}
                >
                  Qtd. Min.
                </Form.ControlLabel>
                <Form.Control
                  name="qtdMin"
                  type="number"
                  value={qtdMin}
                  onChange={setQtdMin}
                  accepter={CustomInput}
                  style={{ width: '100%' }}
                />
              </Form.Group>
            </Col>
            <Col xs={24} md={4}>
              <Form.Group>
                <Form.ControlLabel
                  style={{
                    color: theme.colors.textSecondary,
                    marginTop: '10px',
                  }}
                >
                  Qtd. Máx.
                </Form.ControlLabel>
                <Form.Control
                  name="qtdMin"
                  type="number"
                  value={qtdMax}
                  onChange={setQtdMax}
                  accepter={CustomInput}
                  style={{ width: '100%' }}
                />
              </Form.Group>
            </Col>
            <Col xs={24} md={5}>
              <Form.Group>
                <Form.ControlLabel
                  style={{
                    color: theme.colors.textSecondary,
                    marginTop: '10px',
                  }}
                >
                  Incremento
                </Form.ControlLabel>
                <Form.Control
                  name="qtdMin"
                  type="number"
                  min={1}
                  value={incrementar}
                  onChange={setIncrementar}
                  accepter={CustomInput}
                  style={{ width: '100%' }}
                />
              </Form.Group>
            </Col>
            <Col xs={24} md={6}>
              <Form.Group>
                <Form.ControlLabel
                  style={{
                    color: theme.colors.textSecondary,
                    marginTop: '10px',
                  }}
                >
                  Add. Item mais vezes
                </Form.ControlLabel>
                <CustomSelectPicker
                  style={{ width: '100%' }}
                  data={[
                    { value: 'True', label: 'Sim' },
                    { value: 'False', label: 'Não' },
                  ]}
                  searchable={false}
                  value={addMaisVezes}
                  onChange={setAddMaisVezes}
                />
              </Form.Group>
            </Col>
          </Row>
          <FlexboxGrid justify="end" style={{ margin: '10px 0px', gap: 10 }}>
            <CustomButton appearance="ghost" onClick={close}>
              Fechar
            </CustomButton>
            <CustomButton
              appearance="primary"
              onClick={montagem ? editarMontagem : cadastrarMontagem}
            >
              Salvar
            </CustomButton>
          </FlexboxGrid>
        </Grid>
      </Form>
    </RModal>
  );
};

export default EditCreateMontagens;
